import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  // ✅ Sirf admin info check karo
  const admin = localStorage.getItem("admin");

  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}

export default ProtectedRoute;